import NewsroomContainer from "./containers/NewsroomContainer";
export default NewsroomContainer;
